import React from 'react'
import Highcharts from 'highcharts'
import HighchartsWrapper from './HighChartsWrapper'
import { ColumnChartCardProps } from '../../utils'

const ColumnChartCard: React.FC<ColumnChartCardProps> = ({
  categories,
  series,
  xAxisTitle = '',
  yAxisTitle = '',
}) => {
  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories,
      title: {
        text: xAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 12,
      },
      lineWidth: 1,
      lineColor: 'var(--accent-900)',
      tickLength: 12,
      tickColor: 'var(--accent-900)',
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 20,
      },
      gridLineColor: 'var(--accent-100)',
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      backgroundColor: 'rgba(255,255,255,0.95)',
      borderColor: '#ccc',
      style: {
        color: '#000',
        fontSize: '13px',
      },
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemStyle: { color: 'var(--accent-900)', fontWeight: '500' },
      enabled: false,
    },
    plotOptions: {
      column: {
        borderRadius: 4,
        pointPadding: 0.2,
        borderWidth: 0,
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
          },
        },
      },
    },
    series: series.map((s) => ({
      ...s,
      type: 'column',
    })),
    credits: {
      enabled: false,
    },
  }

  return (
    <HighchartsWrapper
      options={chartOptions}
      containerProps={{ className: 'h-fit w-full' }}
    />
  )
}

export default ColumnChartCard
